module.exports = __webpack_public_path__ + "img/1.cb437db0.png";